import { CALL_API } from "../api.middleware";
import {
  VERIFY_OTP_LAMF,
  VERIFY_OTP_LAMF_SUCCESS,
  GET_CLIENT_DATA_LAMF,
  GET_CLIENT_DATA_LAMF_SUCCESS,
} from "../types";

export const sendOtpLamf = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          url: "/lamf",
          method: "POST",
          body: {
            body,
            endPoint: "/user/sendOTP",
          },
        },
      });
    } catch (error) {
      console.trace(error);
    }
  };
};

export const verifyOtpLamf = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          url: "/lamf",
          method: "POST",
          body: {
            body,
            endPoint: "/user/verifyotp",
          },
          types: [VERIFY_OTP_LAMF, VERIFY_OTP_LAMF_SUCCESS],
        },
      });
    } catch (error) {
      console.trace(error);
    }
  };
};

export const getClientDataLamf = (body) => {
  return async (dispatch) => {
    try {
      return await dispatch({
        [CALL_API]: {
          url: "/lamf",
          method: "POST",
          body: {
            body,
            endPoint: "/referral/refer",
          },
          types: [GET_CLIENT_DATA_LAMF, GET_CLIENT_DATA_LAMF_SUCCESS],
        },
      });
    } catch (error) {
      console.trace(error);
    }
  };
};
